export default {
  SET_ERROR_MESSAGE: (state, error_msg) => (state.error_msg = error_msg),
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_SUCCESS: (state, success) => (state.success = success),
  SET_GOVERNORATES: (state, governorates) =>
    (state.governorates = governorates),
  SET_CITIES: (state, cities) => (state.cities = cities),
  SET_STATIONS_LIST: (state, stationList) => (state.stationList = stationList),
  SET_HOODS_LIST: (state, hoodsList) => (state.hoodsList = hoodsList),
  SET_COOPS_LIST: (state, coopsList) => (state.coopsList = coopsList),
  SET_DISEASES_LIST: (state, diseases) => (state.diseases = diseases),
  SET_MEDICINES_LIST: (state, medicines) => (state.medicines = medicines),
};
